import { ComponentProps } from "react";
// eslint-disable-next-line no-restricted-imports
import { Navigate } from "react-router";
import { useGlobalContext } from "@utils/GlobalContext";

export const Forward = ({ to, ...props }: ComponentProps<typeof Navigate>) => {
  const { locale } = useGlobalContext();

  return (
    <Navigate
      {...props}
      to={`/${locale.toLocaleLowerCase()}${to === "/" ? "" : to}`}
    />
  );
};
